import React from 'react';
import { Chip } from '@progress/kendo-react-buttons';
import { useIntl } from 'hooks/intl';
import styles from './style.module.scss';

export interface FpHeaderProjectStatusProps {
    projectTypeName: string
    projectStatus: string
}

export function FpHeaderProjectStatus(props: FpHeaderProjectStatusProps) {
  const intl = useIntl();

  return (
    <div className={styles.header__menu__projectStatus}>
      { props.projectTypeName && <Chip rounded="full" text={props.projectTypeName} /> }
      { props.projectStatus && <Chip rounded="full" text={intl.formatMessage(`label.project_status.${props.projectStatus}`)} /> }
    </div>
  );
}
